<template>
  <div v-if="shouldRenderPage">
	<div id="planStreamDropDown" class="course-search-section">
    <b-input-group class="row data-row header_search_container">
        <span style="display: inline-block; width: 39px;">
          <span class="icon-filter" @click.stop.prevent="openDropDownClicked" v-if="$parent.isShowFilterIcon"></span>
        </span>
        <input type="text"
               ref="searchBox"
               class="input-search"
               aria-label="type in search term and/or click search"
               placeholder="type in search term and/or click search"
               v-on:keyup.enter="searchButtonClicked"
               v-model.trim="searchText"
               @click.stop.prevent="openDropDownClicked">
        <button class="btn search-button-container" @click.stop.prevent="searchButtonClicked">search</button>
    </b-input-group>
	</div>

  <b-popover ref='catalogSearchPopover' container="dropDownContainer" target='planStreamDropDown' :show.sync='showCatalogSearchDropDown'
        :no-fade='true'>
        <div>
          <div class='header-content-row'>
           <button class="btn_close" aria-label="close" @click="closeDropDown">
                <span class="ic-close"></span>
            </button>
          </div>
          <div>
            <div>
              <b-input-group>
                <input type="text" id='keywordsTextbox' class="input-search"
                placeholder="type in search term and/or click search"
                aria-label="type in search term and/or click search"
                v-on:keyup.enter="searchButtonClicked"
                v-model.trim="searchText">
                <button @click="closeDropDown" aria-label="course search" class="fa fa-cog"></button>
                <button class="btn search-button-container" aria-label="search" @click="searchButtonClicked">search</button>
              </b-input-group>
              <div class="course-search-field-section">
                <b-input-group v-if="catalogFlagMap.showDepartmentCriteria.enabled" prepend='Department:'>
                  <div class="row field-row">
                    <div v-if="catalogFlagMap.showDepartmentCriteria.label" class="col-5 label">
                      {{catalogFlagMap.showDepartmentCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Department
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='department' :options='departments'></v-select>
                      <span id="departmentToolTip" v-if='departmentToolTipText && departmentToolTipText.length > 0'>{{departmentToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>
                <b-input-group v-if="catalogFlagMap.showSubjectCriteria.enabled" prepend='Subject:'>
                  <div class="row field-row">
                    <div v-if="catalogFlagMap.showSubjectCriteria.label" class="col-5 label">
                      {{catalogFlagMap.showSubjectCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Subject
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='subject' :options='subjects'></v-select>
                      <span id="subjectToolTip" v-if='subjectToolTipText && subjectToolTipText.length > 0'>{{subjectToolTipText}}</span>
                    </div>
                  </div>

                </b-input-group>
                <b-input-group v-if="catalogFlagMap.showDivisionCriteria.enabled" prepend='Division:'>
                  <div class="row field-row">
                    <div v-if="catalogFlagMap.showDivisionCriteria.label" class="col-5 label">
                      {{catalogFlagMap.showDivisionCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Division
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='division' :options='divisions'></v-select>
                      <span id="divisionToolTip" v-if='divisionToolTipText && divisionToolTipText.length > 0'>{{divisionToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

              </div>
            </div>
          </div>
          <div class='footer-section'>
            <div class='content-row-1'>
              <b-button-toolbar class='float-right'>
                <b-btn size='sm' @click="clearAll" aria-label="clear all">Clear All</b-btn>
                <b-btn size='sm' @click="closeDropDown" aria-label="close">Close</b-btn>
              </b-button-toolbar>
            </div>
            <div class="content-row-2">
              <button class="btn search-button" @click="searchButtonClicked" aria-label="search">Search</button>
            </div>

          </div>
        </div>
    </b-popover>

  <div id="dropDownContainer" class="course-search-section"></div>

	<b-popover ref='courseSearchPopover' container="dropDownContainer" target='planStreamDropDown' :show.sync='showCourseSearchDropDown'
        :no-fade='true'>
        <div>
          <div class='header-content-row'>
            <span class="title">{{titleText}}</span>
             <button class="btn_close" aria-label="close" @click="closeDropDown">
                   <span class="ic-close"></span>
                </button>
          </div>
          <div>
            <div>
              <b-input-group>
                <input type="text" id='keywordsTextbox' class="input-search"
                placeholder="type in search term and/or click search"
                aria-label="type in search term and/or click search"
                v-on:keyup.enter="searchButtonClicked"
                v-model.trim="searchText">
                <button @click.stop.prevent="closeDropDown" aria-label="course search" class="fa fa-cog"></button>
                <button class="btn search-button-container" aria-label="search" @click.stop.prevent="searchButtonClicked">search</button>
              </b-input-group>
              <div class="course-search-field-section">
                <b-input-group v-if="courseSearchFlagMap.showYearCriteria.enabled" prepend='Year:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showYearCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showYearCriteria.label}} <span id='yearInputGroup' v-if="courseSearchFlagMap.savedSearch.enabled" class="exclamation-circle"><span class="ico-error"></span></span>
                    </div>
                    <div v-else class="col-5 label">
                      Year <span id='yearInputGroup' v-if="courseSearchFlagMap.savedSearch.enabled" class="exclamation-circle"><span class="ico-error"></span></span>
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='year' :options='years'></v-select>
                    </div>
                  </div>
                  <b-popover v-if="courseSearchFlagMap.savedSearch.enabled" target="yearInputGroup" triggers="hover" container="yearInfo" :title="yearNotSavedWarningText"></b-popover>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showSemesterCriteria.enabled" prepend='Semester:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showSemesterCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showSemesterCriteria.label}} <span id='semesterInputGroup' v-if="courseSearchFlagMap.savedSearch.enabled" class="exclamation-circle"><span class="ico-error"></span></span>
                    </div>
                    <div v-else class="col-5 label">
                      Semester <span id='semesterInputGroup' v-if="courseSearchFlagMap.savedSearch.enabled" class="exclamation-circle"><span class="ico-error"></span></span>
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='semester' :options='semesters'></v-select>
                    </div>
                  </div>
                  <b-popover v-if="courseSearchFlagMap.savedSearch.enabled" target="semesterInputGroup" triggers="hover" container="semeseterInfo" :title="semesterNotSavedWarningText"></b-popover>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showDepartmentCriteria.enabled" prepend='Department:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showDepartmentCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showDepartmentCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Department
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='department' :options='departments'></v-select>
                      <span id="departmentToolTip" class="warning_msg" v-if='departmentToolTipText && departmentToolTipText.length > 0'><span class="icon-warning"></span> {{departmentToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showDivisionCriteria.enabled" prepend='Division:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showDivisionCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showDivisionCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Division
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='division' :options='divisions'></v-select>
                      <span id="divisionToolTip" class="warning_msg" v-if='divisionToolTipText && divisionToolTipText.length > 0'><span class="icon-warning"></span> {{divisionToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showSubjectCriteria.enabled" prepend='Subject:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showSubjectCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showSubjectCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Subject
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='subject' :options='subjects'></v-select>
                      <span id="subjectToolTip" class="warning_msg" v-if='subjectToolTipText && subjectToolTipText.length > 0'><span class="icon-warning"></span> {{subjectToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showInstructorCriteria.enabled" prepend='Instructor:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showInstructorCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showInstructorCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Instructor
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='instructor' :options='instructors'></v-select>
                      <span id="instructorToolTip" class="warning_msg" v-if='instructorToolTipText && instructorToolTipText.length > 0'><span class="icon-warning"></span> {{instructorToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showMajorsCriteria.enabled" prepend='Major:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showMajorsCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showMajorsCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Major
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='major' :options='majors'></v-select>
                      <span id="majorToolTip" class="warning_msg" v-if='majorToolTipText && majorToolTipText.length > 0'><span class="icon-warning"></span> {{majorToolTipText}}</span>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showUnitsCriteria.enabled" prepend='Units:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showUnitsCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showUnitsCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Units
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='unit' :options='units'></v-select>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showCourseSearchFlagCriteria.enabled">
                  <div class="row field-row course-flag-row">
                    <div v-if="courseSearchFlagMap.showCourseSearchFlagCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showCourseSearchFlagCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      {{courseSectionLabel}} Flags
                    </div>
                    <div class="col-7 field-column course-flag">
                      <div class="flag-container">
                        <b-input-group stacked>
                          <div class="inner-field-row" v-for='courseFlag in formattedCourseFlags'>
                            <input type="checkbox" v-model="courseFlag.selected" :id="courseFlag.key" @input='flagSelected(courseFlag)'></input>
                            <label class="title" :for="courseFlag.key">{{courseFlag.value}}</label>
                          </div>
                        </b-input-group>
                      </div>
                    </div>
                  </div>
                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showDaysCriteria.enabled">
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showDaysCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showDaysCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Class Days
                    </div>
                    <div class="col-7 field-column class-days">
                      <b-input-group>
                        <div class="inner-field-column">
                          <input type="checkbox" v-model="monday" id="mondayCheckbox"></input>
                          <label class="title" for="mondayCheckbox">Mon</label>
                        </div>
                        <div class="inner-field-column">
                          <input type="checkbox" v-model="tuesday" id="tuesdayCheckbox"></input>
                          <label class="title"  for="tuesdayCheckbox">Tue</label>
                        </div>

                        <div class="inner-field-column">
                          <input type="checkbox" v-model="wednesday" id="wednesdayCheckbox"></input>
                          <label class="title" for="wednesdayCheckbox">Wed</label>
                        </div>

                        <div class="inner-field-column">
                          <input type="checkbox" v-model="thursday" id="thursdayCheckbox"></input>
                          <label class="title" for="thursdayCheckbox">Thu</label>
                        </div>

                        <div class="inner-field-column">
                          <input type="checkbox" v-model="friday" id="fridayCheckbox"></input>
                          <label class="title" for="fridayCheckbox">Fri</label>
                        </div>
                      </b-input-group>
                    </div>
                  </div>


                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showTimeCriteria.enabled">
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showTimeCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showTimeCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Class Time
                    </div>
                    <div class="col-7 field-column class-time">
                      <b-input-group>
                        <b-form-select v-model="classTimeFrom" id="classTimeFromSelect">
                          <option v-for="time in formattedStartTimes" :value="time">{{time}}</option>
                        </b-form-select>
                        <span class="separator-column"> to </span>
                        <b-form-select v-model="classTimeTo">
                          <option v-for="time in formattedEndTimes" :value="time">{{time}}</option>
                        </b-form-select>
                      </b-input-group>
                    </div>
                  </div>

                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showBlockCriteria.enabled">
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showBlockCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showBlockCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Class Block
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='block' :options='blocks'></v-select>
                    </div>
                  </div>

                </b-input-group>

                <b-input-group v-if="courseSearchFlagMap.showGradeLevelCriteria.enabled" prepend='Level:'>
                  <div class="row field-row">
                    <div v-if="courseSearchFlagMap.showGradeLevelCriteria.label" class="col-5 label">
                      {{courseSearchFlagMap.showGradeLevelCriteria.label}}
                    </div>
                    <div v-else class="col-5 label">
                      Class Level
                    </div>
                    <div class="col-7 field-column">
                      <v-select :clearable="false" class="select-field" v-model='level' :options='levels'></v-select>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
          </div>
          <div class='footer-section'>
            <div class='content-row-1'>
              <b-button-toolbar class='float-right'>
                <b-btn size='sm' @click="closeDropDown" aria-label="close">close</b-btn>
                <b-btn size='sm' @click="clearAll" aria-label="clear all">clear all</b-btn>
                <b-btn size='sm' v-if="courseSearchFlagMap.savedSearch.enabled"
                        variant='primary' @click='saveButtonClicked'
                        :disabled="permission.systemPermission.readOnly" aria-label="save">save</b-btn>
              </b-button-toolbar>
            </div>
            <div class="content-row-2">
              <button class="btn search-button-container" @click="searchButtonClicked" aria-label="search">search</button>
            </div>

          </div>
        </div>
        <div id='titlePopoverContainer' class="save-search-popup" v-if='showTitlePopover'>
          <b-popover :show.sync='showTitlePopover' ref='titlePopover' target='courseSearchDropDown'
                     container='titlePopoverContainer'>
          <div class='header-content-row'>{{title}}</div>
          <b-input-group>
            <div class="row">
              <div class="col-4 title">Name of your {{courseSectionLabel}} Search</div>
              <div class="col-8">
                <b-form-input type='text'
                placeholder='Title'
                v-model='title'></b-form-input>
              </div>
            </div>
          </b-input-group>
          <div class='footer-section'>
            <div class='content-row-1'>
              <b-button-toolbar class='float-right'>
                <b-btn @click='cancelSaveClicked' aria-label="cancel">
                  cancel
                </b-btn>
                <b-btn variant='primary' @click='save' aria-label="save">
                  ok
                </b-btn>
              </b-button-toolbar>
            </div>
          </div>
        </b-popover>
      </div>
    </b-popover>
  </div>

</template>

<script>
  import '../../../assets/module/css/discover/courseSearch.min.css'
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import Autocomplete from 'vuejs-auto-complete'

  export default {
    name: 'plan-stream-drop-down',
    components: {
      Autocomplete
    },
    data: () => {
      return {
        masterSearchFeatureId: PACKAGE.FEATURE_IDS.MASTER_SEARCH_FEATURE_ID,
        catalogSearchFeatureId: PACKAGE.FEATURE_IDS.CATALOG_SEARCH_FEATURE_ID,
        courseSearchFeatureId: PACKAGE.FEATURE_IDS.COURSE_SEARCH_FEATURE_ID,
        tagSearchFeatureId: PACKAGE.FEATURE_IDS.TAG_SEARCH_FEATURE_ID,
        uuid: {},
        title: '',
        searchText: '',
        department: 'Any Department',
        subject: 'Any Subject',
        division: 'Any Division',
        instructor: 'Any Instructor',
        major: 'Any Major',
        unit: 'Any Number',
        qr: false,
        keywords: '',
        firstyear: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        classTimeFrom: 'any time',
        classTimeTo: 'any time',
        classBlockFrom: 'any block',
        classBlockTo: 'any block',
        semesterMap: {
          '201910': 'Spring 2019',
          '201880': 'Fall 2018',
          '201810': 'Spring 2018'
        },
        semesterCodeMap: {
          'Spring 2019': '201910',
          'Fall 2018': '201880',
          'Spring 2018': '201810'
        },
        semester: 'Spring 2019',
        semesters: ['Spring 2019', 'Fall 2018', 'Spring 2018'],
        currentSemesterCode: '201910',
        showTitlePopover: false,
        courseSearchObject: {},
        showCourseSearchDropDown: false,
        showCatalogSearchDropDown: false,
        showOtherSearchDropDown: false,
        selectedFlags: [],
        lastSelectedCourseSearch: {},
        departmentToolTipText: '',
        divisionToolTipText: '',
        subjectToolTipText: '',
        instructorToolTipText: '',
        majorToolTipText: '',
        level: 'Any Level',
        block: 'Any Block',
        yearMap: {'Any Year': 'ALL', '': 'ALL'},
        year: 'Any Year',
        years: ['Any Year', '2017-2018', '2018-2019'],
        ALL_YEARS_CODE: 'ALL',
        ALL_TERMS_CODE: 'ALL',
        userId: localStorage.getItem('userid'),
        userObject: JSON.parse(localStorage.getItem('userobj')),
        institutionId: localStorage.getItem('institutionId'),
        COURSE_SEARCH: 'COURSE',
        CATALOG_SEARCH: 'CATALOG',
        OTHER_SEARCH: 'OTHER'
      }
    },
    created () {
    },
    async mounted () {
      this.institutionId = this.institution.uuid || this.userObject.institutionId
      await this.loadInstitutionPackage({uuid: this.institutionId, isAggregated: false})
      await this.loadPermission()
      await this.loadData()
    },
    methods: {
      ...mapActions([
        'loadCourseSearches',
        'loadCourseFlags',
        'loadDataForCourseSearch',
        'storeCourseSearch',
        'removeCourseSearch',
        'updateCourseSearchState',
        'updateSearchType',
        'constructSearchQuery',
        'loadPermission',
        'loadInstitutionDetail',
        'loadInstitutionPackage',
        'updateCourseSearchFlags',
        'loadInstitutionDetail',
        'loadLogDashboardActivity',
        'updateSemesterMap',
        'loadPublicInstitutionDetail'
      ]),

      async loadData () {
        let institution = this.institution
        if (institution.semesterMap) {
          this.semesters = Object.values(institution.semesterMap).sort()
          this.semester = institution.semesterMap[institution.currentSemester]
          this.semesterMap = institution.semesterMap
          this.semesterCodeMap = _.invert(this.semesterMap)
        }
        if (institution.yearMap) {
          let yearLabel = 'Any Year'
          if (this.courseSearchFlagMap.showYearCriteria.enabled && this.courseSearchFlagMap.showYearCriteria.label) {
            yearLabel = 'Any ' + this.courseSearchFlagMap.showYearCriteria.label
          }
          this.yearMap = {}
          this.years = Object.keys(institution.yearMap).sort().filter(year => year !== this.ALL_YEARS_CODE)
          this.years.forEach((year) => {
            this.yearMap[year] = year
          })
          this.years.unshift(yearLabel)
          this.yearMap[yearLabel] = this.ALL_YEARS_CODE
          this.year = this.years[this.years.length - 1] // default to latest academic year

          // construct new semester map with term codes from the current academic year
          this.buildNewSemesterMap(this.year)
        }
        let currentYear = (this.searchByYearEnabled) ? this.yearMap[this.year] : ''
        let currentSemesterCode = institution.currentSemester

        await this.loadDataForCourseSearch({currentYear: currentYear, currentSemester: currentSemesterCode})
        await this.loadCourseFlags({libraryUuid: this.institutionId, semesterCode: currentSemesterCode})
        await this.loadCourseSearches()
        this.executeCourseSearch()
      },
      mapInputForSaving (input, map) {
        input = (input && input.label) ? input.label : input
        if (!input || input.startsWith('Any')) {
          return ''
        } else if (Object.keys(map).includes(input)) {
          return map[input]
        }
        return input
      },
      mapInputForDisplay (input, map, defaultValue, toolTipText) {
        this[toolTipText] = ''
        if (!input) {
          return defaultValue
        } else if (Object.values(map).includes(input)) {
          return _.invert(map)[input]
        } else if (!Object.values(map).includes(input)) {
          // A course search was loaded with the wrong corresponding semester
          // display red tool tip below the cleared out criteria
          let text = 'The ' + defaultValue.split(' ')[1] + ' \'' + input + '\' is not available for ' + this.semester
          this[toolTipText] = text
          return defaultValue
        }
        return input
      },
      saveButtonClicked () {
        this.showTitlePopover = true
      },
      executeCourseSearch (courseSearchData) {
        // NOTE: pass null explicitly to override the default parameter (the JS event) in HTML
        if (!courseSearchData) {
          courseSearchData = this.getDataForSaving()
        }
        // TODO separate state from advancedSearch so popovers do not interfere?
        courseSearchData['courseSearchTimeStamp'] = new Date()
        this.lastSelectedCourseSearch = courseSearchData
        courseSearchData.termCode = (this.currentSemesterCode !== this.ALL_TERMS_CODE) ? this.currentSemesterCode : ''
        this.updateCourseSearchState({ courseSearchData: courseSearchData })
        this.updateCourseSearchFlags(this.courseSearchFlagMap)
        this.closeDropDown()
        this.showTitlePopover = false
        this.loadLogDashboardActivity({action: 'clickCourseSearch', page: 'courseSectionDropDown', link: ''})
        this.$emit('search-button-clicked', this.searchText)
      },
      executeCatalogSearch () {
        let courseSearchData = {}
        courseSearchData['semester'] = this.semester
        courseSearchData['keywords'] = (this.searchText) ? this.searchText.split(' ').join(',') : ''
        // saving the values instead of the keys (instead of CourseSearch)
        courseSearchData['department'] = (this.department && this.department.label) ? this.department.label : ''
        courseSearchData['subject'] = (this.subject && this.subject.label) ? this.subject.label : ''
        courseSearchData['division'] = (this.division && this.division.label) ? this.division.label : ''
        courseSearchData['termCode'] = (this.semester) ? this.semesterCodeMap[this.semester] : this.semester
        courseSearchData['catalogSearchTimeStamp'] = new Date()
        if (courseSearchData['department'] && courseSearchData['department'].startsWith('Any')) {
          courseSearchData['department'] = ''
        }
        if (courseSearchData['subject'] && courseSearchData['subject'].startsWith('Any')) {
          courseSearchData['subject'] = ''
        }
        if (courseSearchData['division'] && courseSearchData['division'].startsWith('Any')) {
          courseSearchData['division'] = ''
        }
        this.lastSelectedCourseSearch = {}
        this.updateCourseSearchState({ courseSearchData: courseSearchData })
        this.$emit('search-button-clicked', this.searchText)
        this.closeDropDown()
        this.showTitlePopover = false
      },
      executeOtherEntitiesSearch () {
        let courseSearchData = {}
        courseSearchData['keywords'] = (this.searchText) ? this.searchText.split(' ').join(',') : ''
        this.updateCourseSearchState({ courseSearchData: courseSearchData })
        this.$emit('search-button-clicked', this.searchText)
      },
      getDataForSaving () {
        const courseSearchData = {}
        if (this.uuid) {
          courseSearchData['uuid'] = this.uuid
        }

        courseSearchData['semester'] = this.semesterCodeMap[this.semester] !== this.ALL_TERMS_CODE ? this.semester : ''
        courseSearchData['selectedSemesters'] = this.selectedSemesters()
        courseSearchData['academicYear'] = this.yearMap[this.year] !== this.ALL_YEARS_CODE ? this.year : ''
        courseSearchData['searchName'] = this.title
        courseSearchData['keywords'] = (this.searchText) ? this.searchText.split(' ').join(',') : ''
        courseSearchData['department'] = this.computedDepartment
        courseSearchData['subject'] = this.computedSubject
        courseSearchData['division'] = this.computedDivision
        courseSearchData['termCode'] = (this.semesterCodeMap[this.semester] !== this.ALL_TERMS_CODE) ? this.semesterCodeMap[this.semester] : ''
        courseSearchData['instructor'] = this.computedInstructor
        courseSearchData['major'] = this.computedMajor
        courseSearchData['qr'] = this.qr
        courseSearchData['firstyear'] = this.firstyear
        courseSearchData['day'] = this.day
        courseSearchData['unit'] = this.computedUnits
        courseSearchData['classTimeFrom'] = (this.classTimeFrom !== 'any time') ? this.classTimeFrom : ''
        courseSearchData['classTimeTo'] = (this.classTimeTo !== 'any time') ? this.classTimeTo : ''
        courseSearchData['courseFlags'] = this.selectedFlags
        courseSearchData['lastUpdatedTime'] = new Date()
        courseSearchData['monday'] = this.monday
        courseSearchData['tuesday'] = this.tuesday
        courseSearchData['wednesday'] = this.wednesday
        courseSearchData['thursday'] = this.thursday
        courseSearchData['friday'] = this.friday

        // CSW
        courseSearchData['level'] = this.computedLevel
        courseSearchData['block'] = this.computedBlock
        return courseSearchData
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      save () {
        if (!this.title) {
          this.notifyFailure('title cannot be blank')
          return
        }

        const courseSearchData = this.getDataForSaving()
        this.closeDropDown()
        this.storeCourseSearch({courseSearchObj: courseSearchData, libraryId: this.institutionId}).then(response => {
          this.uuid = response.uuid
          this.notifySuccess('Course Search \'' + this.title + '\' created successfully.')
          // NOTE: race condition discovered, so doing one more call here to ensure courseSearches are updated in VM
          this.loadCourseSearches()
          this.showTitlePopover = false
          this.executeCourseSearch(courseSearchData)
        })
        this.showTitlePopover = false
      },
      setDaysFromMap (dayMap) {
        if (!dayMap) return
        this.monday = (dayMap.monday) ? dayMap.monday : false
        this.tuesday = (dayMap.tuesday) ? dayMap.tuesday : false
        this.wednesday = (dayMap.wednesday) ? dayMap.wednesday : false
        this.thursday = (dayMap.thursday) ? dayMap.thursday : false
        this.friday = (dayMap.friday) ? dayMap.friday : false
      },
      setData (data) {
        let department = this.mapInputForDisplay(data.department, this.departmentMap, 'Any ' + this.departmentLabel, 'departmentToolTipText')
        let subject = this.mapInputForDisplay(data.subject, this.subjectMap, 'Any ' + this.subjectLabel, 'subjectToolTipText')
        let division = this.mapInputForDisplay(data.division, this.divisionMap, 'Any ' + this.divisionLabel, 'divisionToolTipText')
        let instructor = this.mapInputForDisplay(data.instructor, this.instructorMap, 'Any ' + this.instructorLabel, 'instructorToolTipText')
        let major = this.mapInputForDisplay(data.major, this.majorMap, 'Any ' + this.majorLabel, 'majorToolTipText')
        let block = this.mapInputForDisplay(data.block, this.blockMap, 'Any ' + this.blockLabel, 'blockToolTipText')
        let level = this.mapInputForDisplay(data.level, this.levelMap, 'Any ' + this.levelLabel, 'levelToolTipText')
        let searchText = (data.keywords) ? data.keywords.split(',').join(' ') : data.searchText

        this.setDaysFromMap(data.day)

        this.formattedCourseFlags.forEach(function (flag) {
          flag.selected = false
        })

        this.uuid = data.uuid
        this.title = data.searchName
        this.searchText = searchText
        this.department = department
        this.subject = subject
        this.division = division
        this.instructor = instructor
        this.major = major
        this.unit = (!data.unit || isNaN(data.unit)) ? 'Any Number' : data.unit
        this.qr = data.qr
        this.keywords = data.keywords
        this.firstyear = data.firstyear
        this.classTimeFrom = (data.classTimeFrom) ? (data.classTimeFrom) : 'any time'
        this.classTimeTo = (data.classTimeTo) ? (data.classTimeTo) : 'any time'
        // CSW
        this.block = block
        this.level = level

        this.selectedFlags = (data.courseFlags) ? (data.courseFlags.slice()) : []
        if (!this.selectedFlags || this.selectedFlags.length === 0) {
          return
        }

        // set courseFlag checkboxes
        let courseFlags = this.formattedCourseFlags
        this.selectedFlags.forEach(function (f) {
          courseFlags.forEach(function (flag) {
            if (flag.key === f) {
              flag.selected = true
            }
          })
        })
      },
      resetValues () {
        const data = {
          uuid: '',
          searchName: '',
          searchText: '',
          department: null,
          subject: null,
          division: null,
          instructor: null,
          major: '',
          unit: '',
          semester: '',
          qr: false,
          keywords: '',
          firstyear: false,
          day: {},
          classTimeFrom: '',
          classTimeTo: '',
          block: '',
          level: ''
        }
        this.setData(data)
        if (this.semesters.length > 0) {
          this.semester = this.semesters[0]
        }
        if (this.years.length > 0) {
          this.year = this.years[0]
        }
      },
      courseSearchSelected (courseSearch) {
        this.resetValues()
        this.setData(courseSearch)
        this.lastSelectedCourseSearch = courseSearch
        this.$emit('course-search-selected')
        this.openDropDownClicked()
      },
      deleteSavedCourseSearch (courseSearch) {
        let searchName = courseSearch.searchName
        let institutionId = this.institutionId

        this.removeCourseSearch({courseSearch: courseSearch, libraryId: institutionId}).then(response => {
          this.notifySuccess('Course Search \'' + searchName + '\' deleted successfully.')
        })
        this.showTitlePopover = false
      },
      clearAll () {
        this.lastSelectedCourseSearch = {}
        this.resetValues()
      },
      flagSelected (flag) {
        if (!flag.selected) {
          this.selectedFlags.push(flag.key.slice())
        } else {
          let index = 0
          let flagIndex = -1
          this.selectedFlags.forEach(function (f) {
            if (f === flag.key) {
              flagIndex = index
            }
            index += 1
          })

          if (flagIndex === 0) {
            this.selectedFlags.shift()
          } else if (flagIndex === this.selectedFlags.length - 1) {
            this.selectedFlags.pop()
          } else {
            this.selectedFlags.splice(flagIndex, 1)
          }
        }
      },
      cancelSaveClicked () {
        this.resetValues()
        this.showTitlePopover = false
      },
      closeDropDown () {
        this.showCourseSearchDropDown = false
        this.showCatalogSearchDropDown = false
        this.showOtherSearchDropDown = false
      },
      formatOptionsForVSelect (map, sort, nullKey) {
        let formatted = []
        if (sort) {
          Object.keys(map).sort().forEach((key, i) => {
            if (!key.startsWith('Any')) {
              formatted.push({id: i, label: key})
            }
          })
          formatted.unshift({id: 0, label: 'Any ' + nullKey})
        } else {
          Object.keys(map).forEach((key, i) => {
            if (key.startsWith('Any') && nullKey) {
              formatted.push({id: i, label: 'Any ' + nullKey})
            } else {
              formatted.push({id: i, label: key})
            }
          })
        }

        return formatted
      },
      buildNewSemesterMap (year) {
        let newSemesterMap = {}
        if (!year || year === this.ALL_YEARS_CODE || this.yearMap[year] === this.ALL_YEARS_CODE) {
          newSemesterMap = this.institution.semesterMap
        } else {
          let currentYear = this.yearMap[year]
          let semesterCodes = this.institution.yearMap[currentYear]
          semesterCodes.forEach((semester) => {
            newSemesterMap[semester] = this.institution.semesterMap[semester]
          })
        }
        let searchByAnySemesterEnabled = this.searchByAnySemesterEnabled
        if (searchByAnySemesterEnabled) {
          newSemesterMap[this.ALL_TERMS_CODE] = 'Any ' + this.semesterLabel
        }
        this.semesters = Object.values(newSemesterMap).sort()
        this.semesterMap = newSemesterMap
        this.semesterCodeMap = _.invert(newSemesterMap)
        let currentSemester = this.institution.currentSemester
        this.semester = currentSemester && currentSemester.length > 0 ? newSemesterMap[currentSemester] : this.semester
        this.updateSemesterMap({semesterMap: newSemesterMap})
      },
      selectedSemesters () {
        let activeSemesters = []
        if (this.semesterCodeMap[this.semester] === this.ALL_TERMS_CODE) {
          activeSemesters = Object.keys(this.semesterCodeMap).filter(key => this.semesterCodeMap[key] !== this.ALL_YEARS_CODE)
        } else {
          activeSemesters = [this.semester]
        }
        return activeSemesters
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      openDropDownClicked () {
        // watchers will close any open dropdowns
        let searchType = this.searchType
        if (searchType === this.COURSE_SEARCH) {
          this.showCourseSearchDropDown = true
        }
        if (searchType === this.CATALOG_SEARCH) {
          this.showCatalogSearchDropDown = true
        }
        if (searchType === this.OTHER_SEARCH) {
          this.showOtherSearchDropDown = true
        }
      },

      searchButtonClicked () {
        let searchAction
        let searchType = this.searchType
        if (searchType === this.COURSE_SEARCH) {
          searchAction = this.executeCourseSearch
        }
        if (searchType === this.CATALOG_SEARCH) {
          searchAction = this.executeCatalogSearch
        }
        if (searchType === this.OTHER_SEARCH) {
          searchAction = this.executeOtherEntitiesSearch
        }
        let resetFacets = false
        return searchAction(resetFacets)
      }
    },
    computed: {
      ...mapState({
        'departmentMap': state => state.search.departmentMap,
        'divisionMap': state => state.search.divisionMap,
        'subjectMap': state => state.search.subjectMap,
        'instructorMap': state => state.search.instructorMap,
        'majorMap': state => state.search.majorMap,
        'units': state => Object.keys(state.search.unitMap),
        'startTimes': state => Object.keys(state.search.startTimeMap),
        'endTimes': state => Object.keys(state.search.endTimeMap),
        'blockMap': state => state.search.blockMap,
        'levelMap': state => state.search.levelMap,
        'libraryList': state => state.search.libraryList,
        'courseSearches': state => state.search.courseSearches,
        'shouldShowDropDown': state => state.search.shouldShowDropDown,
        'lastUpdatedTime': state => state.search.lastUpdatedTime,
        'courseFlags': state => state.search.courseFlags,
        'permission': state => state.user.permission,
        'institution': state => state.institution.institution,
        'packages': state => state.institution.packages,
        'publicInstitution': state => state.institution.publicInstitution,
        'planStreamSearchType': state => state.stream.planStreamSearchType
      }),
      searchType () {
        let planStreamSearchType = this.planStreamSearchType
        if (!planStreamSearchType || !planStreamSearchType.length) {
          // default to Course Search
          return this.COURSE_SEARCH
        }
        if (planStreamSearchType === this.COURSE_SEARCH) {
          return this.COURSE_SEARCH
        }
        if (planStreamSearchType === this.CATALOG_SEARCH) {
          return this.CATALOG_SEARCH
        }
        if (planStreamSearchType === this.OTHER_SEARCH) {
          return this.OTHER_SEARCH
        }
      },
      courseSearchObj () {
        let courseSearch = this.courseSearchObject
        return courseSearch
      },
      semesterLabel () {
        let label = 'Semester'
        if (this.courseSearchFlagMap.showSemesterCriteria.enabled && this.courseSearchFlagMap.showSemesterCriteria.label) {
          label = this.courseSearchFlagMap.showSemesterCriteria.label
        }
        return label
      },
      departments () {
        let doSort = false
        return this.formatOptionsForVSelect(this.departmentMap, doSort, this.departmentLabel)
      },
      computedDepartment () {
        return this.mapInputForSaving(this.department, this.departmentMap)
      },
      departmentLabel () {
        let label = 'Department'
        if (this.courseSearchFlagMap.showDepartmentCriteria.enabled && this.courseSearchFlagMap.showDepartmentCriteria.label) {
          label = this.courseSearchFlagMap.showDepartmentCriteria.label
        }
        return label
      },
      divisions () {
        let doSort = false
        return this.formatOptionsForVSelect(this.divisionMap, doSort, this.divisionLabel)
      },
      computedDivision () {
        return this.mapInputForSaving(this.division, this.divisionMap)
      },
      divisionLabel () {
        let label = 'Division'
        if (this.courseSearchFlagMap.showDivisionCriteria.enabled && this.courseSearchFlagMap.showDivisionCriteria.label) {
          label = this.courseSearchFlagMap.showDivisionCriteria.label
        }
        return label
      },
      subjects () {
        let doSort = false
        return this.formatOptionsForVSelect(this.subjectMap, doSort, this.subjectLabel)
      },
      computedSubject () {
        return this.mapInputForSaving(this.subject, this.subjectMap)
      },
      subjectLabel () {
        let label = 'Subject'
        if (this.courseSearchFlagMap.showSubjectCriteria.enabled && this.courseSearchFlagMap.showSubjectCriteria.label) {
          label = this.courseSearchFlagMap.showSubjectCriteria.label
        }
        return label
      },
      instructors () {
        let doSort = false
        return this.formatOptionsForVSelect(this.instructorMap, doSort, this.instructorLabel)
      },
      computedInstructor () {
        return this.mapInputForSaving(this.instructor, this.instructorMap)
      },
      instructorLabel () {
        let label = 'Instructor'
        if (this.courseSearchFlagMap.showInstructorCriteria.enabled && this.courseSearchFlagMap.showInstructorCriteria.label) {
          label = this.courseSearchFlagMap.showInstructorCriteria.label
        }
        return label
      },
      majors () {
        let doSort = false
        return this.formatOptionsForVSelect(this.majorMap, doSort, this.majorLabel)
      },
      computedMajor () {
        return this.mapInputForSaving(this.major, this.majorMap)
      },
      majorLabel () {
        let label = 'Major'
        if (this.courseSearchFlagMap.showMajorsCriteria.enabled && this.courseSearchFlagMap.showMajorsCriteria.label) {
          label = this.courseSearchFlagMap.showMajorsCriteria.label
        }
        return label
      },
      levels () {
        let doSort = true
        return this.formatOptionsForVSelect(this.levelMap, doSort, this.levelLabel)
      },
      computedLevel () {
        return this.mapInputForSaving(this.level, this.levelMap)
      },
      levelLabel () {
        let label = 'Level'
        if (this.courseSearchFlagMap.showGradeLevelCriteria.enabled && this.courseSearchFlagMap.showGradeLevelCriteria.label) {
          label = this.courseSearchFlagMap.showGradeLevelCriteria.label
        }
        return label
      },
      blocks () {
        let doSort = true
        return this.formatOptionsForVSelect(this.blockMap, doSort, this.blockLabel)
      },
      computedBlock () {
        return this.mapInputForSaving(this.block, this.blockMap)
      },
      blockLabel () {
        let label = 'Block'
        if (this.courseSearchFlagMap.showBlockCriteria.enabled && this.courseSearchFlagMap.showBlockCriteria.label) {
          label = this.courseSearchFlagMap.showBlockCriteria.label
        }
        return label
      },
      formattedUnitsForVSelect () {
        let formatted = []
        this.units.forEach((unit, i) => {
          formatted.push({id: i, label: i})
        })
        return formatted
      },
      computedUnits () {
        let unit = this.unit
        return (unit.startsWith('Any')) ? '' : unit
      },
      titleText () {
        if (!this.title) {
          return this.courseSectionLabel + ' Search'
        } else {
          return this.title
        }
      },
      courseSearchOptions () {
        let courseSearches = this.courseSearches
        let options = []
        courseSearches.forEach(function (obj) {
          options.push({text: obj.searchName, value: obj})
        })
        return options
      },
      formattedCourseFlags () {
        let formattedFlags = []
        let courseFlags = this.courseFlags
        Object.keys(courseFlags).forEach(function (key) {
          formattedFlags.push({key: key, value: (courseFlags[key] || key), selected: false})
        })
        return formattedFlags
      },
      day () {
        const dayMap = {
          monday: this.monday,
          tuesday: this.tuesday,
          wednesday: this.wednesday,
          thursday: this.thursday,
          friday: this.friday
        }
        return dayMap
      },
      formattedStartTimes () {
        let startTimes = this.startTimes
        if (!startTimes || !startTimes.length || startTimes.length <= 0) {
          return ['any time']
        }
        let sorted = startTimes.sort((a, b) => {
          return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b)
        })
        sorted.unshift('any time')
        return sorted
      },
      formattedEndTimes () {
        let endTimes = this.endTimes
        if (!endTimes || !endTimes.length || endTimes.length <= 0) {
          return ['any time']
        }
        if (this.classTimeFrom && this.classTimeFrom.length && this.classTimeFrom.length > 0) {
          endTimes = endTimes.filter(time => new Date('1970/01/01 ' + time) > new Date('1970/01/01 ' + this.classTimeFrom))
        }
        let sorted = endTimes.sort((a, b) => {
          return new Date('1970/01/01 ' + a) - new Date('1970/01/01 ' + b)
        })
        sorted.unshift('any time')
        return sorted
      },
      featureMap () {
        // merge the three search features into one map for readibility
        let masterSearchFeature = this.masterSearchFeatureId
        let courseFeature = this.courseSearchFeatureId
        let catalogFeature = this.catalogSearchFeatureId
        let tagSearchFeature = this.tagSearchFeatureId
        let featureMap = {}

        featureMap[masterSearchFeature] = {enabled: false}
        featureMap[courseFeature] = {enabled: false}
        featureMap[catalogFeature] = {enabled: false}
        featureMap[tagSearchFeature] = {enabled: false}

        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return featureMap
        }

        let coursePlanningPackage = this.getCoursePlanningPackage()
        if (!coursePlanningPackage || !coursePlanningPackage.features) {
          return featureMap
        }

        coursePlanningPackage.features.forEach((feature) => {
          let currFeature = featureMap[feature.featureId]
          if (currFeature) {
            featureMap[feature.featureId].enabled = feature.enabled
            featureMap[feature.featureId].label = feature.label
          }
        })
        return featureMap
      },
      courseSearchFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.COURSE_SEARCH_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      catalogFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.CATALOG_SEARCH_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      shouldRenderPage () {
        let permission = this.permission
        let featureMap = this.featureMap
        let masterSearchFeatureId = this.masterSearchFeatureId
        return permission && permission.version === '5' && featureMap && featureMap[masterSearchFeatureId] && featureMap[masterSearchFeatureId].enabled
      },
      courseSearchEnabled () {
        let featureMap = this.featureMap
        let courseSearchFeatureId = this.courseSearchFeatureId
        return featureMap && featureMap[courseSearchFeatureId] && featureMap[courseSearchFeatureId].enabled
      },
      semesterNotSavedWarningText () {
        let semesterLabel = 'semester'
        if (this.courseSearchFlagMap.showSemesterCriteria.enabled && this.courseSearchFlagMap.showSemesterCriteria.label) {
          semesterLabel = this.courseSearchFlagMap.showSemesterCriteria.label
        }
        return 'Note: ' + semesterLabel + ' criteria is not saved'
      },
      yearNotSavedWarningText () {
        let semesterLabel = 'year'
        if (this.courseSearchFlagMap.showYearCriteria.enabled && this.courseSearchFlagMap.showYearCriteria.label) {
          semesterLabel = this.courseSearchFlagMap.showYearCriteria.label
        }
        return 'Note: ' + semesterLabel + ' criteria is not saved'
      },
      courseSectionLabel () {
        let isEnabled = this.featureMap[this.courseSearchFeatureId].enabled
        let customLabel = this.featureMap[this.courseSearchFeatureId].label
        let label = 'Plan'
        if (isEnabled && customLabel) {
          label = customLabel
        }
        return label
      },
      searchByAnySemesterEnabled () {
        let courseSearchFlagMap = this.courseSearchFlagMap
        if (!courseSearchFlagMap || !courseSearchFlagMap.enableSearchByAnySemester) {
          return false
        }
        return courseSearchFlagMap.enableSearchByAnySemester.enabled
      },
      searchByYearEnabled () {
        let courseSearchFlagMap = this.courseSearchFlagMap
        if (!courseSearchFlagMap || !courseSearchFlagMap.showYearCriteria) {
          return false
        }
        return courseSearchFlagMap.showYearCriteria.enabled
      }
    },
    watch: {
      showCourseSearchDropDown (newShouldShow) {
        if (newShouldShow === true) {
          this.showCatalogSearchDropDown = false
          this.showOtherSearchDropDown = false
        }
      },
      showCatalogSearchDropDown (newShouldShow) {
        if (newShouldShow === true) {
          this.showCourseSearchDropDown = false
          this.showOtherSearchDropDown = false
        }
      },
      showOtherSearchDropDown (newShouldShow) {
        if (newShouldShow === true) {
          this.showCatalogSearchDropDown = false
          this.showCourseSearchDropDown = false
        }
      },
      lastUpdatedTime (newTime) {
        this.openDropDownClicked()
        this.setData(this.lastSelectedCourseSearch)
      },
      semester (newSemester) {
        if (newSemester) {
          this.currentSemesterCode = this.semesterCodeMap[newSemester]
        }

        let institutionId = this.institutionId
        let currentSemesterCode = this.currentSemesterCode
        let lastSelectedCourseSearch = this.lastSelectedCourseSearch
        if (lastSelectedCourseSearch.semester) {
          lastSelectedCourseSearch.semester = newSemester
        }

        let currentYear = (this.searchByYearEnabled) ? this.yearMap[this.year] : ''

        this.loadDataForCourseSearch({currentYear: currentYear, currentSemester: currentSemesterCode}).then((response) => {
          this.loadCourseFlags({libraryUuid: institutionId, semesterCode: currentSemesterCode})
          this.setData(lastSelectedCourseSearch)
          // this.updateCourseSearchFlags(this.courseSearchFlagMap)
        })
      },
      year (newYear) {
        this.year = newYear
        let lastSelectedCourseSearch = this.lastSelectedCourseSearch
        if (lastSelectedCourseSearch.year) {
          lastSelectedCourseSearch.year = newYear
        }
        if (!newYear) {
          return
        }

        this.buildNewSemesterMap(newYear)

        let currentYear = this.yearMap[newYear]
        let institutionId = this.institutionId
        let currentSemesterCode = this.currentSemesterCode
        this.loadDataForCourseSearch({currentYear: currentYear, currentSemester: currentSemesterCode}).then((response) => {
          this.loadCourseFlags({libraryUuid: institutionId, semesterCode: currentSemesterCode})
          this.setData(lastSelectedCourseSearch)
          // this.updateCourseSearchFlags(this.courseSearchFlagMap)
        })
      }
    }
  }
</script>

<style>
    .tag-search-section {
        height: 250px !important;
        z-index: 1111 !important;
    }

    .tag-search-field-section {
        float: left;
        width: 100%;
        margin-top: 11px;
        max-height: calc(100vh - 220px);
        min-height: 115px;
    }

    .autocomplete__box {
        width: 98% !important;
    }

    .autocomplete__results__item {
        float: none !important;
    }

    .tag-container {
        margin-right: 10px;
        border: 1px solid #939393;
    }

    .tag-name {
        color: #000;
        padding: 3px;
        font-size: small;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .delete {
        border: 1px solid #939393;
        border-radius: 3px;
        height: 25px;
        background: #ffffff;
        margin: 0px -1px 5px 0px;
    }

    .delete-icon {
        margin: 5px;
        cursor: pointer;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/app/stream/components/PlanStreamDropDown.vue